// import-sort-ignore

//
// Error tracking
//
export { default as configureErrorTracking } from './tracking/configureErrorTracking';
export { default as trackException } from './tracking/trackException';
export {
  shouldIgnoreNetworkError,
  shouldTrackNetworkError,
} from './tracking/shouldTrackNetworkError';

//
// Error plugin
//
import ActionTypes from './plugin/ActionTypes';
import reducer from './plugin/reducer';
export default {
  reducers: {
    errors: reducer,
  },
  actionTypes: ActionTypes,
};
export { default as ErrorActionTypes } from './plugin/ActionTypes';
export { default as ErrorActions } from './plugin/ErrorActions';
import * as ErrorSelectors from './plugin/Selectors';
export { ErrorSelectors };

//
// Other error-related stuff
//
export { default as createErrorType } from './createErrorType';
export { default as resourceNames } from './resourceNames';
export { default as commonErrors } from './commonErrors';

export {
  isPermanentError,
  hasErrorsOfType,
  selectErrorMessages,
} from './utils';
